import React from "react";
import styled, {css} from "styled-components";
import baseStyle from "../../style";
import CurrencyInput from "react-currency-input";
import { useFieldValue } from "../../hooks";

import * as colors from "../../../../assets/_base/colors"

const Currency = styled(CurrencyInput)`
  ${baseStyle};

  ${props =>{
    if(props.invalid){
      return css`
        border: 1px solid ${colors.danger} !important;
        color: ${colors.danger} !important;

        :focus, :active {
          border: 2px solid ${colors.danger} !important;
          color: ${colors.danger} !important;
        }
      `
    }
  }}
`;

export default (props) => {
  const [getFieldNameValue] = useFieldValue();

  function onChange(e, doubleValue) {
    if (props.onChange) {
      const data = getFieldNameValue({ type: "currency" }, e, doubleValue);
      props.onChange(data);
    }
  }

  return (
    <Currency
      disabled={props.disabled}
      decimalSeparator=","
      thousandSeparator="."
      precision="2"
      prefix="R$ "
      onChange={onChange}
      value={props.value}
      invalid={props.invalid}
    />
  );
};



// WEBPACK FOOTER //
// ./src/_components/Input/components/Currency/index.jsx